module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAA5klEQVRIx2M4xi1HI8QwajT9jP5/hFYIp8Tn3QyTitkmFLEBGdQ0+vhMFn9jrigLtnAz9iATLiCXOkZn+zGHuzKH2bDoqzCbaTMHW7Nk+DPlBTJRweiZdZLVqWLJqlyJapzJIaGxPr7t+bJtORJUMHpyvEKevaSbtpCDqqibseW+Wavq/OUbA6WoYPTUFJU0J6lYTT5HDdkYR+WJ2Tx1Yar1QfJUMHpeo3p9lmKKBUeaJcf+Kez7+tln1Wl05itRweikCOnoQOnuBKl0f736RKMdzXKxoTIxobJUS9dUyDKjxdNwMBoAc/z3YAcWdMQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Content/Assets/images/flags/es.png
// module id = 1372
// module chunks = 0